import snackBar from "src/utilities/snackBar/SnackBar"

const UnalignedHandler = {
    go: false,
    a: 0,
    b: 0,
    timeoutID: undefined,
    check: () => {
        const a = UnalignedHandler.a
        const b = UnalignedHandler.b
        if ((a !== b)) {
            snackBar({ text: "Employee details ar unaligned, force refresh triggered", type: "error", timeout: 5000 })
            setTimeout(() => {
                window.location.reload()
            }, 5000)
        }
        if (UnalignedHandler.go) {
            //@ts-ignore
           UnalignedHandler.timeoutID =  setTimeout(() => {
                UnalignedHandler.check()
            }, 1000)
        }
    },
    init: (a: string | number, b: string | number) => {
        //@ts-ignore
        UnalignedHandler.a = parseInt(a)
        //@ts-ignore
        UnalignedHandler.b = parseInt(b)
        UnalignedHandler.go = true
        UnalignedHandler.check()
    },
    kill: () => {
        UnalignedHandler.go = false
        UnalignedHandler.a = 0
        UnalignedHandler.b = 0
        clearTimeout(UnalignedHandler.timeoutID)
    },
    update: (key: string, value: string | number) => {
        //@ts-ignore
        UnalignedHandler[key] = parseInt(value)
    }
}


export default UnalignedHandler
